import { z } from 'zod';

export const pdPromotionStateSchema = z.union([
  z.object({ status: z.literal('inactive') }),
  z.object({ status: z.literal('active'), promotionId: z.string() }),
]);
